import { render, staticRenderFns } from "./CommentsView.vue?vue&type=template&id=fdb1dcf8&scoped=true&"
import script from "./CommentsView.vue?vue&type=script&lang=js&"
export * from "./CommentsView.vue?vue&type=script&lang=js&"
import style0 from "./CommentsView.vue?vue&type=style&index=0&id=fdb1dcf8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdb1dcf8",
  null
  
)

export default component.exports